import React, { useMemo } from 'react';
import { CardWrapper } from './styles';
import { Space } from 'antd';
import { DynamicObjectType } from 'core/types/common';
import {
  EXCHANGE_CANCEL_REASONS,
  EXCHANGE_REASON,
} from 'constants/ordersExchange';
import { useTranslation } from 'react-i18next';
import GridPhotos from 'components/commons/GridPhotos';

const exchangeCancelReason = {
  ...EXCHANGE_CANCEL_REASONS,
  DUPLICATED: {
    value: 'DUPLICATED',
    text: 'orders.reasons.duplicated',
  },
  BUYER_CHANGE_MIND: {
    value: 'BUYER_CHANGE_MIND',
    text: 'orders.reasons.buyerChangeMind',
  },
  OTHER: {
    value: 'OTHER',
    text: 'orders.reasons.other',
  },
};

const ExchangeInformation = ({ data }: { data: DynamicObjectType }) => {
  const { t } = useTranslation();

  const _exchangeInformation = useMemo(() => {
    return [
      {
        title: t('ordersExchange.reason'),
        value: t(EXCHANGE_REASON[data?.orderReturn?.reason]?.text),
      },
      // {
      //   title: t('ordersExchange.whoPayShippingFee'),
      //   value: t(
      //     WHO_PAY_SHIPPING_FEE[data?.orderReturn?.whoPayShippingFee]?.text,
      //   ),
      // },
      {
        title: t('ordersExchange.note'),
        value: data?.orderReturn?.note,
      },
      {
        title: t('ordersExchange.image'),
        images: data?.orderReturn?.images,
      },
    ];
  }, [data]);

  return (
    <CardWrapper title="Exchange Information">
      <Space direction="vertical" size={10}>
        {_exchangeInformation?.map((item, index) => (
          <Space key={index} size={5} className="w-full" direction="vertical">
            <div className="font-bold text-[--text-dark-gray]">
              {item?.title}
            </div>
            {!item?.images ? (
              <div className="text-[--text-dark-gray]">{item?.value}</div>
            ) : (
              <GridPhotos
                images={item?.images}
                width={80}
                height={80}
                maxPreview={5}
                className="!mr-[5px]"
              />
            )}
          </Space>
        ))}
        {(data?.status === 'CANCELLED' || data?.cancelReason) && (
          <>
            <div className="fw-600">{t('orderDetail.cancelledReason')}</div>
            <div>
              {data?.cancelReason &&
                t(exchangeCancelReason[data?.cancelReason]?.text || '')}
            </div>
            <div className="color-dark-gray fw-400 opacity-40 italic">
              {data?.cancelNote || ''}
            </div>
          </>
        )}
      </Space>
    </CardWrapper>
  );
};

export default ExchangeInformation;
